import { Model } from '@vuex-orm/core';
import { uuidv4 } from '@/utils/helpers';

export default class Folder extends Model {
  static entity = 'folders';

  static fields() {
    return {
      id: this.attr(() => uuidv4()),
      name: this.attr(''),
      parent_id: this.attr(null),
      created_at: this.attr(''),
      updated_at: this.attr(''),
    };
  }
}
